import {
  createFrontendModule,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { formFieldsApiRef } from '@backstage/plugin-scaffolder/alpha';

export const ibictScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    SubPageBlueprint.makeWithOverrides({
      name: 'templates',
      factory(originalFactory, { apis }) {
        const formFieldsApi = apis.get(formFieldsApiRef);
        return originalFactory({
          path: 'templates',
          title: 'Modelos',
          loader: async () => {
            const formFields = (await formFieldsApi?.loadFormFields()) ?? [];
            return import('./IbictTemplatesPage').then(m => (
              <m.IbictTemplatesPage formFields={formFields} />
            ));
          },
        });
      },
    }),
    SubPageBlueprint.makeWithOverrides({
      name: 'tasks',
      factory(originalFactory) {
        return originalFactory({
          path: 'tasks',
          title: 'Tasks',
          loader: async () =>
            import('./IbictTasksPage').then(m => <m.IbictTasksPage />),
        });
      },
    }),
  ],
});
